import { Credentials } from "./models";

export abstract class Chain {
    initialize!: Credentials;
    constructor(initialize: Credentials) {
        this.initialize = {
            apiKey: initialize.apiKey,
            authorization: initialize.authorization,
            env: initialize.env
        }
    }  
}